/*
* loading Actions
*
* @version 1.0.0
* @author Chiara Amato
* @since 16-Jun-2022
*/

import {
  // createRequestTypes,
  createAction
  // MakeRequest,
} from './index'

export const actionTypes = {
  DO_GLOBAL_LOADING: '@@loading/global_loading',
  DO_LOCAL_LOADING: '@@loading/local_loading'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action
/** @action
     * * Insert a description
     * @name LocalLoading
     * @return {object} - The payload object
     */
export const doLocalLoading = payload => createAction(actionTypes.DO_LOCAL_LOADING, { payload })
/** @action
     * * Insert a description
     * @name GlobalLoading
     * @return {object} - The payload object
     */
export const doGlobalLoading = payload => createAction(actionTypes.DO_GLOBAL_LOADING, { payload })
